import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import React, { Component } from 'react';
import MainPageWithParams from './MainPage';
import AppTheme from './shared-theme/AppTheme.js';
import SignIn from './SignIn.js';
import { CssBaseline } from '@mui/material';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

function MainPageWrapper() {
  const { slug } = useParams();
  return <MainPageWithParams slug={slug} />;
}

export default class App extends Component {
  render() {
    return (
      <AppTheme {...this.props} disableCustomTheme={false} themeComponents={xThemeComponents}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path="/" element={<SignIn />} />
            <Route path="/admin/*" element={<div>Admin lives on Django — not React.</div>} />
            <Route path="/:slug" element={<MainPageWrapper />} />
          </Routes>
        </Router>
      </AppTheme>
    );
  }
}
